var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-lab.a56cf48d.png","uri@2x": __webpack_public_path__ + "icon-lab.0857be01.png","uri@3x": __webpack_public_path__ + "icon-lab.f4727f0f.png",
    width: 20,
    height: 20
});